var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"bg-primary sombra"},[_c('div',{staticClass:"container bg-primary"},[_c('div',{staticClass:"pt-5 ml-4 ml-md-0"},[_c('img',{staticClass:"img-fluid bounceIn logo-foo",attrs:{"src":require("@/assets/images/Logo-Kia.png"),"alt":"KIA LOGO"}})])])])
}]

export { render, staticRenderFns }